import React from 'react'
import PropTypes from 'prop-types'
import { useWebRtcPlayback } from '../../hooks/useWebRtcPlayback'

const WebRtcPlayer = ({ setStreamingInProgress, streamingInProgress }) => {
  useWebRtcPlayback(setStreamingInProgress, streamingInProgress)

  const videoStyle = {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    backgroundColor: 'black',
  }

  return <video id="tcplayer-video" playsInline preload="auto" style={videoStyle} />
}

export { WebRtcPlayer }

WebRtcPlayer.propTypes = {
  setStreamingInProgress: PropTypes.func,
  streamingInProgress: PropTypes.bool,
}
